import React, { useEffect, useState, useRef } from "react";

import { NavLink, useNavigate, useLocation } from "react-router-dom";

import "./Header.css";

import SessionTimeoutComponent from "../../Controls/SessionPopup/sessionpopup";

import RefreshToken from "../../Controls/RefreshToken/RefreshToken";

import { useSelector, useDispatch } from "react-redux";
import { AppContext } from "../../../AppContext";
import { languageChange, currentSelectedLanguage, removeConfiguredData, retainConfiguredData, resetSettingsState, isRShieldConfigured, resetRShieldOptions } from "../../../StateManagement/actions";
import ModalPopUp from "../../Controls/ModalPopUp/ModalPopUp";
import { resetFormData, requestResetControls, requestRemoveExcelFiles } from "../../../StateManagement/formChanges-slice";


const Header = ({
  isOpen,
  onMouseDown,
  menuName,
  pageRestrictionData,
  securitylevelvalue,
  authorizedReaders,
  inputFields
}) => {
  //const[isShowSettingTab,setIsShowSettingtab]=useState(localStorage.getItem("showSettingTab"));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const unSaveWarnModal = useRef();
  //  useEffect(()=>{
  //   localStorage.removeItem("SSOType");
  //  })
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const data = useSelector((state) => state.pageLevelRestriction);
  const identifyLeakers = useSelector((state) => state.identifyLeakers);

  const formChanges = useSelector((state) => state.formChanges);
  const rShield = useSelector((state) => state.rShield);
  const settings = useSelector((state) => state.settings);

  function logoutClick() {
    if (localStorage.getItem("SSOType") == ("AzureAD" || "Google")) {
      var LogoutUrl = AppContext.RCapLogoutUrl;
      var LoginUrl = `${process.env.REACT_APP_DomainUrl}`;
      var email = localStorage.getItem("UserName");
      localStorage.setItem("LogoutUrl", LogoutUrl);
      localStorage.setItem("domainUrl", LoginUrl);

      var authenticateUrl =
        LogoutUrl +
        "rpost-authentication-logout" +
        "?logoutcallbackurl=" +
        LoginUrl +
        "&emailAddress =" +
        email +
        "&ssotype=" +
        localStorage.getItem("SSOType");

      if (localStorage.getItem("showLoginPopup") != null) {
        var showLoginPopup = localStorage.getItem("showLoginPopup");
        if (showLoginPopup == "Y") {
          authenticateUrl =
            LogoutUrl +
            "rpost-authentication-logout?" +
            "?logoutcallbackurl=" +
            LoginUrl +
            "&emailAddress =" +
            email +
            "&ssotype=" +
            localStorage.getItem("SSOType");
        }
      }
      dispatch(resetSettingsState());
      localStorage.removeItem("SSOType");
      localStorage.removeItem("UserRole");
      localStorage.removeItem("Companyname");
      window.location.href = authenticateUrl;
    } else {
      // var LoginUrl = `${process.env.REACT_APP_DomainUrl}`;
      // var authenticateUrl =
      //    LogoutUrl + process.env.REACT_APP_SSOLogout
      //    window.location.href = authenticateUrl;
      dispatch(resetSettingsState());
      navigate("/");
    }
  }

  const hasExcelFiles = () => {
    return inputFields?.some((file) => [".xls", ".xlsx"].includes(file?.fileFormat?.toLowerCase()));
  };

  const removeConfiguredDataHandler = (e, tab) => {
    e.preventDefault();
    console.log("formData", formChanges);
    const isFormDataChanged = formChanges.formData.find((item) => item?.isDataChanged);
    const inputFieldsChanged = (inputFields) ? inputFields.length > 0 : false;
    let readersAdded = data.authorizedReaders.length > 0;
    const rShieldConfigured = isRShieldConfigured(rShield);
    //const pageRestrictionDataChanged = (pageRestrictionData) ? pageRestrictionData.length > 0 : false;

    if (location.pathname === '/create' && isFormDataChanged) {
      if (isFormDataChanged.type === "SendVerificationCode" || isFormDataChanged.type === "EmailBody" || isFormDataChanged.type === "ProofOfSending") {
        dispatch(removeConfiguredData());
        dispatch(resetFormData());
        navigate(tab);
        return;
      }
    }

    if ((location.pathname === '/create' || location.pathname === "/send") && data.authorizedReaders.length > 0 && securitylevelvalue === 3) {
      const readers = data.authorizedReaders.reduce((acc, i) => {
        if (i[0] !== localStorage.getItem("UserName")) {
          return acc.concat(i[0]);
        }
        return acc;
      }, []);
      if (readers.length === 0) {
        readersAdded = false;
        //dispatch(removeConfiguredData());
        //dispatch(resetFormData());
      }
    }

    if (location.pathname === '/create' &&
      (securitylevelvalue === 2 || securitylevelvalue === 1) &&
      (readersAdded) &&
      (tab === '/history' || tab === '/settings')) {
      readersAdded = false;
      dispatch(removeConfiguredData());
      dispatch(resetFormData());
    }
    if (isFormDataChanged ||
      inputFieldsChanged ||
      //pageRestrictionDataChanged || 
      readersAdded || rShieldConfigured) {
      const msg = selectedLanguage.LstLanguageCodes.UI_ConfirmationMessage;
      unSaveWarnModal.current.open(
        msg,
        () => {
          dispatch(removeConfiguredData());
          dispatch(resetFormData());
          dispatch(resetRShieldOptions());
          navigate(tab);
        },
        () => {
          //navigate(location.pathname);
        }
      );
    } else {
      navigate(tab);
      dispatch(removeConfiguredData());
      dispatch(resetFormData());
      dispatch(resetRShieldOptions());
    }
  };
  const handleSendNavigation = (e) => {
    e.preventDefault();
    // if (
    //   window.location.pathname === "/history" ||
    //   window.location.pathname === "/settings"
    // ) {
    //   removeConfiguredDataHandler();
    // }
    if (location.pathname === "/rpdlite") {
      if (hasExcelFiles()) {
        const msg = selectedLanguage.LstLanguageCodes.UI_RPDLiteExcelRemovalConfirmation;
        unSaveWarnModal.current.open(msg,
          // CONFIRM
          () => {
            dispatch(requestRemoveExcelFiles());
            navigate("/send");
          },
          // CANCEL
          () => {
            // Stay on RPDLite
          }
        );
        return;
      }
      navigate("/send");
      return;
    }
    if (securitylevelvalue === 2) {

      if (pageRestrictionData && pageRestrictionData.length > 0) {
        const exceptNoReadersRestrictions = pageRestrictionData.filter(
          (item) => {
            if (
              item.category === "Selected Readers"
              ||
              item.category === "Everyone Except Selected Readers"

            ) {
              return { ...item };
            }
          }
        );
        if (exceptNoReadersRestrictions.length === 0) {
          dispatch(
            retainConfiguredData({
              isConfirm: true,
              pageRestrictionData,
              authorizedReaders,
            })
          );
          navigate("/send");
          return;
        }

        let msg =
          selectedLanguage.LstLanguageCodes
            .UI_ConfiguredPageRestrictionsRemoval;
        unSaveWarnModal.current.open(
          msg,
          () => {
            dispatch(
              retainConfiguredData({
                isConfirm: true,
                pageRestrictionData,
                authorizedReaders,
              })
            );
            navigate("/send");
          },
          () => {
            dispatch(removeConfiguredData());
            navigate("/send");
          }
        );
      } else {
        dispatch(
          retainConfiguredData({
            isConfirm: authorizedReaders.length > 0 ? true : false,
            authorizedReaders,
            pageRestrictionData: [],
          })
        );
        navigate("/send");
      }
    } else {
      if (pageRestrictionData && authorizedReaders) {
        e.preventDefault();

        dispatch(
          retainConfiguredData({
            isConfirm: true,
            pageRestrictionData,
            authorizedReaders,
          })
        );
      }
      navigate("/send");
    }
    // if (securitylevelvalue === 1) {
    //   e.preventDefault();

    //   dispatch(
    //     retainConfiguredData({
    //       isConfirm: true,
    //       pageRestrictionData: [],
    //       authorizedReaders,
    //     })
    //   );
    //   navigate("/send");
    // }
  };
  const handleCreateNavigation = (e) => {
    e.preventDefault();
    // if (
    //   window.location.pathname === "/history" ||
    //   window.location.pathname === "/settings"
    // ) {
    //   removeConfiguredDataHandler();
    // }
    if (location.pathname === "/rpdlite") {
      if (hasExcelFiles()) {
        const msg = selectedLanguage.LstLanguageCodes.UI_RPDLiteExcelRemovalConfirmation;
        unSaveWarnModal.current.open(msg,
          // CONFIRM
          () => {
            dispatch(requestRemoveExcelFiles());
            navigate("/create");
          },
          // CANCEL
          () => {
            // Stay on RPDLite
          }
        );
        return;
      }
      navigate("/create");
      return;
    }

    if (securitylevelvalue === 2) {

      if (pageRestrictionData && pageRestrictionData.length > 0) {
        const exceptNoReadersRestrictions = pageRestrictionData.filter(
          (item) => {
            if (
              item.category ===
              "Selected Readers" ||
              item.category === "Everyone Except Selected Readers"
            ) {
              return { ...item };
            }
          }
        );
        if (exceptNoReadersRestrictions.length === 0) {
          dispatch(
            retainConfiguredData({
              isConfirm: true,
              pageRestrictionData,
              authorizedReaders,
            })
          );
          navigate("/create");
          return;
        }
        let msg =
          selectedLanguage.LstLanguageCodes.UI_AllConfiguredRestrictionsRemoved;
        unSaveWarnModal.current.open(
          msg,
          () => {
            dispatch(removeConfiguredData());
            navigate("/create");
          },
          () => { }
        );
      } else {
        dispatch(
          retainConfiguredData({
            isConfirm: authorizedReaders.length > 0 ? true : false,
            authorizedReaders,
            pageRestrictionData: [],
          })
        );
        navigate("/create");
      }
    } else if (
      (securitylevelvalue === 3 || securitylevelvalue === 1) &&
      pageRestrictionData &&
      authorizedReaders
    ) {
      e.preventDefault();

      dispatch(
        retainConfiguredData({
          isConfirm: true,
          pageRestrictionData,
          authorizedReaders,
        })
      );
      navigate("/create");
    }
    if (!securitylevelvalue) {
      navigate("/create");
    }
    // if (securitylevelvalue === 1) {
    //   e.preventDefault();
    //   dispatch(
    //     retainConfiguredData({
    //       isConfirm: true,
    //       pageRestrictionData: [],
    //       authorizedReaders,
    //     })
    //   );
    //   navigate("/create");
    // }
  };

  const handleRPDLiteNavigation = (e) => {
    e.preventDefault();

    const hasUploadedFiles = Array.isArray(inputFields) && inputFields.length > 0;

    if (!hasUploadedFiles) {
      navigate("/rpdlite");
      return;
    }

    const msg = selectedLanguage.LstLanguageCodes.UI_RPDLitePopulateConfirmation;
    unSaveWarnModal.current.open(msg,
      () => {
        dispatch(
          retainConfiguredData({
            isConfirm: true,
            pageRestrictionData: pageRestrictionData || [],
            authorizedReaders: authorizedReaders || [],
          })
        );
        navigate("/rpdlite");
      },
      () => {
        dispatch(requestResetControls());
        navigate("/rpdlite");
      }
    );
  };

  return (
    <>
      <main className="main" id="top">
        <ModalPopUp ref={unSaveWarnModal} headerText={"Update"} />
        <nav
          className="navbar navbar-expand-lg navbar-light fixed-top py-2 header-shadow header-style"
          data-navbar-on-scroll="data-navbar-on-scroll"
        >
          <div className="container-fluid  res-container-fluid">
            {/* <a className="navbar-brand" href="/send" id="imgClick"  onMouseDown={(e)=>handlenavigation(e)}
                    > */}
            <NavLink
              className="navbar-brand"
              aria-current="page"
              to="/send"
              onMouseDown={onMouseDown}
              onClick={handleSendNavigation}
              name="Send">
              <img
                className="img-fluid logo-img"
                src="assets/img/RDocs.png"
                alt=""
                id="Send"
              />
            </NavLink>
            {/* </a> */}

            <button
              className="navbar-toggler collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent">
              <ul className="navbar-nav me-auto ms-lg-4 ms-xl-7 border-bottom border-lg-bottom-0 pt-2 pt-lg-0 ">
                <li className="nav-item">
                  {/*  pading  */}

                  <NavLink
                    className="nav-link fw-medium res-px0"
                    aria-current="page"
                    to="/send"
                    onMouseDown={onMouseDown}
                    onClick={handleSendNavigation}
                    name="Send">
                    {selectedLanguage.LstLanguageCodes.UI_Send}
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink
                    className="nav-link fw-medium ps-4 res-px0 pl-0p"
                    aria-current="page"
                    to="/create"
                    onMouseDown={onMouseDown}
                    onClick={handleCreateNavigation}
                    name="Create">
                    {selectedLanguage.LstLanguageCodes.UI_Create}
                  </NavLink>
                </li>
                {AppContext.ShowRPDLite && settings.isRPDLiteEnabled && (
                  <li className="nav-item">
                    <NavLink className="nav-link fw-medium ps-4 res-px0 pl-0p" to="/rpdlite" onMouseDown={(e) => onMouseDown?.(e, "/rpdlite")}
                      onClick={handleRPDLiteNavigation} name="RPDLite">
                      <span className="rpdRed">R</span>
                      <span className="rpdBlack">PD</span>
                      <span className="rpdItalic"> Live</span>
                    </NavLink>
                  </li>
                )}
                <li className="nav-item">
                  <NavLink
                    className="nav-link fw-medium ps-4 pl-0p"
                    to="/history"
                    onMouseDown={onMouseDown}
                    onClick={(e) => removeConfiguredDataHandler(e, '/history')}
                    name="Manage">
                    {selectedLanguage.LstLanguageCodes.UI_Manage}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link fw-medium ps-4 pl-0p"
                    onClick={(e) => removeConfiguredDataHandler(e, '/settings')}
                    to="/settings">
                    {selectedLanguage.LstLanguageCodes.UI_Settings}
                  </NavLink>
                </li>
              </ul>

              <form className="d-flex py-3 res-pt0 py-lg-0 dropdown res-form">
                <ul className="navbar-nav ms-auto resme-auto ms-lg-4 justify-content-end  pt-2 pt-lg-0" style={{ alignItems: 'center' }}>
                  <li className="nav-item">
                    <div className="dropdown no-caret">
                      <a className="dropdown-toggle" type="button" id="dropdownMenu22" data-bs-toggle="dropdown" aria-expanded="false">
                        <span className="material-icons user-profile">account_circle</span>
                        <span className="material-icons" style={{ fontSize: '30px', color: '#000' }}> arrow_drop_down </span>
                      </a>
                      <ul className="dropdown-menu right-menulist p-2 ps-0" aria-labelledby="dropdownMenu22">
                        {/* <span className="material-icons drop-arrow">play_arrow</span> */}
                        <li className=" border-bottom-2 py-1" style={{ borderBottom: '1px solid #1111', }}>
                          <a className="dropdown-item d-flex align-items-start" href="javascript:void(0)"
                            aria-current="page" style={{ wordBreak: 'break-word', color: '#000' }}>
                            <span className="material-icons me-2 top-2px" >person</span>
                            <span className="text-wrap">{localStorage.getItem("UserName")}</span>
                          </a>
                        </li>
                        <li className="py-1 ps-0">
                          <a className="dropdown-item d-flex align-items-center" href="javascript:void(0)" onClick={logoutClick} onMouseDown={onMouseDown} id="logout" style={{ color: '#be272e' }}>
                            <span className="material-icons me-2" id="logout" >logout</span>{" "}
                            {selectedLanguage.LstLanguageCodes.UI_LogOut}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </form>
            </div>
          </div>
        </nav>
      </main>

      <SessionTimeoutComponent></SessionTimeoutComponent>

      <RefreshToken></RefreshToken>
    </>
  );
};

export default Header;
